module.exports = __webpack_public_path__ + "img/ru-ud.e70ac69e.svg";